export default __webpack_public_path__ + "static/media/walkle_logo_img.864b5ffc.svg";